var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { id: "modal-container" } },
    [
      _vm._l(_setup.modals, function (modal) {
        return _c(
          "div",
          {
            key: modal.index,
            staticClass: "modal fade show",
            class: { "d-block": modal.show },
            attrs: { role: "dialog", tabindex: "-1" },
            on: {
              click: function ($event) {
                if ($event.target !== $event.currentTarget) return null
                return _setup.hideModal(modal.index)
              },
            },
          },
          [
            _c(_setup.componentsMap[modal.componentName], {
              tag: "component",
              attrs: { modal: modal, options: modal.options },
              on: {
                "hide-modal": function ($event) {
                  return _setup.hideModal(modal.index)
                },
              },
            }),
          ],
          1
        )
      }),
      _vm._v(" "),
      _setup.modals.length > 0
        ? _c("div", { staticClass: "modal-backdrop fade show" })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }